"use client";

import PublicLayout from "@/src/layouts/PublicLayout";
import AppDownloadButton from "@/src/shared/button/AppDownloadButton";
import * as motion from "motion/react-client";
import CallToAction from "@/src/shared/sections/CallToAction";
import AppIcon from "@/src/shared/Icon";

import FeatureSection from "@/components/sections/FeatureSection";

interface HomeViewProps {

}

export default function HomeView() {

    const earningChannels = [
        {
            icon: "watch_video_mobile",
            title: "Watch To Earn",
            desc: "Watch short promotional videos and earn instant rewards.",
        },
        {
            icon: "survey",
            title: "Complete Surveys",
            desc: "Share your opinions on products and services.",
        },
        {
            icon: "task",
            title: "Complete Task",
            desc: "Follow, like, and share on Twitter, Facebook, Instagram and more.",
        },
        {
            icon: "gaming_pad",
            title: "Play To Earn",
            desc: "Play fun mobile games and reach target levels.",
        },
    ];

    const services = [
        {
            icon: "phone_credit_card",
            title: "Buy Data & Airtime.",
            desc: "Get cheap internet data plans and airtime for all networks",
        },
        {
            icon: "bill",
            title: "Pay Bills Instantly.",
            desc: "Pay electricity, cable TV, and other utility bills with ease",
        },
        {
            icon: "bank",
            title: "Withdraw to Bank.",
            desc: "Transfer your earnings directly to any Nigerian bank account",
        }
    ];


    return (
        <PublicLayout>
            <div className="overflow-hidden py-20 sm:py-32 lg:pb-32 xl:pb-36">
                <div className="max-w-340 mx-auto px-4 sm:px-6 lg:px-0">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-8 lg:gap-y-20">
                        <div className="relative z-10 mx-auto max-w-2xl lg:col-span-7 lg:max-w-none lg:pt-6 xl:col-span-6">
                            <h1 className="text-4xl text-gray-900 dark:text-gray-100 font-bold tracking-tight">Earn, Pay and Connect</h1>
                            <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
                                Daily task earn money in Nigeria, unlimited rewards, cheap data plans, and pay bills seamlessly. Download Enanpay app now and join thousands of Nigerians already earning.
                            </p>
                            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-4">
                                <AppDownloadButton 
                                    type="google"
                                    size="xs"
                                    // href="/"
                                />
                                <AppDownloadButton 
                                    type="apple"
                                    size="xs"
                                    // href="/"
                                />
                            </div>
                        </div>
                        <div className="relative mt-10 sm:mt-20 lg:col-span-5 lg:row-span-2 lg:mt-0 xl:col-span-6">
                            <div className="absolute top-4 left-1/2 h-256.5 w-256.5 -translate-x-1/3 mask-[linear-gradient(to_bottom,white_20%,transparent_75%)] stroke-gray-300/70 sm:top-16 sm:-translate-x-1/2 lg:-top-16 lg:ml-12 xl:-top-14 xl:ml-0">
                                <svg viewBox="0 0 1026 1026" fill="none" aria-hidden="true" className="absolute inset-0 h-full w-full animate-spin-slow">
                                    <path d="M1025 513c0 282.77-229.23 512-512 512S1 795.77 1 513 230.23 1 513 1s512 229.23 512 512Z" stroke="#D4D4D4" strokeOpacity="0.7"></path>
                                    <path d="M513 1025C230.23 1025 1 795.77 1 513" stroke="url(#_S_3_-gradient-1)" strokeLinecap="round"></path>
                                    <defs>
                                        <linearGradient id="_S_3_-gradient-1" x1="1" y1="513" x2="1" y2="1025" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#06b6d4"></stop>
                                            <stop offset="1" stopColor="#06b6d4" stopOpacity="0"></stop>
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <svg viewBox="0 0 1026 1026" fill="none" aria-hidden="true" className="absolute inset-0 h-full w-full animate-spin-reverse-slower">
                                    <path d="M913 513c0 220.914-179.086 400-400 400S113 733.914 113 513s179.086-400 400-400 400 179.086 400 400Z" stroke="#D4D4D4" strokeOpacity="0.7"></path>
                                    <path d="M913 513c0 220.914-179.086 400-400 400" stroke="url(#_S_3_-gradient-2)" strokeLinecap="round"></path>
                                    <defs>
                                        <linearGradient id="_S_3_-gradient-2" x1="913" y1="513" x2="913" y2="913" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#06b6d4"></stop>
                                            <stop offset="1" stopColor="#06b6d4" stopOpacity="0"></stop>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            <div className="-mx-4 h-112 mask-[linear-gradient(to_bottom,white_60%,transparent)] px-9 sm:mx-0 lg:absolute lg:-inset-x-10 lg:-top-10 lg:-bottom-20 lg:h-auto lg:px-0 lg:pt-10 xl:-bottom-32">
                                <div className="relative aspect-366/729 mx-auto max-w-91.5">
                                    <img 
                                        src={"/images/screens/home.png"} 
                                        alt="Enanpay app screenshot - earn money online in Nigeria with Enanpay app"
                                        title="dialy task earn money in Nigeria with Enanpay app - watch ads, complete surveys, gaming, and more. Use your earnings to pay electricity bills, buy data bundle, airtime, and withdraw to your bank."
                                        className="h-200 w-auto"
                                        width={"auto"}
                                        height={"auto"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FeatureSection />

            <div className="section items-center">
                <div className="header">
                    <h1 className="title">
                        Our Diverse <strong>Earning Channels</strong>
                    </h1>
                    <p className="subtitle mt-7">
                        Choose from various task categories and start earning immediately. All tasks are designed to be completed quickly on your mobile device.
                    </p>
                </div>

                <div className="w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                        {earningChannels.map((item:any) => {
                            return (
                                <div 
                                    key={item.title}
                                    className=""
                                >
                                    <motion.div
                                        className="flex flex-col gap-y-4 hover:bg-slate-100 dark:hover:bg-gray-800 transition duration-1000 p-7 rounded-xl 
                                                    cursor-pointer"
                                    >
                                        {/* <div className="size-12 bg-gray-400"></div> */}
                                        <AppIcon icon={item.icon} className="text-[3rem] text-gray-400" />
                                        <div>
                                            <h2 className="text-lg text-gray-600 dark:text-gray-300 font-semibold tracking-wider">
                                                { item.title }
                                            </h2>
                                            <p className="text-gray-500 dark:text-gray-400 mt-1">
                                                { item.desc }
                                            </p>
                                        </div>
                                    </motion.div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <CallToAction />

            <div className="section items-center">
                <div className="header">
                    <h1 className="title">
                        <strong>More Than</strong> Just Earning
                    </h1>
                    <p className="subtitle mt-7">
                        Enanpay is your complete financial companion for bill payments, data purchases, and money management.
                    </p>
                </div>

                <div className="body w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-20">
                        {services.map((item:any) => {
                            return (
                                <div 
                                    key={item.title}
                                    className=""
                                >
                                    <motion.div
                                        className="flex flex-col items-center gap-y-4 hover:bg-slate-100 dark:hover:bg-gray-800 transition duration-1000 p-7
                                                    rounded-xl cursor-pointer"
                                    >
                                        {/* <div className="size-12 bg-gray-400"></div> */}
                                        <AppIcon icon={item.icon} className="text-[3rem] text-gray-400" />
                                        <div className="text-center">
                                            <h2 className="text-lg text-gray-600 dark:text-gray-300 font-semibold tracking-wider">
                                                { item.title }
                                            </h2>
                                            <p className="text-gray-500 dark:text-gray-400 mt-1">
                                                { item.desc }
                                            </p>
                                        </div>
                                    </motion.div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
}